export { default } from './EmptyTableBody';
export * from './EmptyTableBody';
export * from './EmptyTableBody.types';
